import React, { useEffect } from 'react';
import { Link, RouteComponentProps } from 'react-router-dom';
import { Button, Row, Col } from 'reactstrap';
import { TextFormat } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { getEntity } from './aidas-user-aidas-object-mapping.reducer';
import { APP_DATE_FORMAT, APP_LOCAL_DATE_FORMAT } from 'app/config/constants';
import { useAppDispatch, useAppSelector } from 'app/config/store';

export const AidasUserAidasObjectMappingDetail = (props: RouteComponentProps<{ id: string }>) => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(getEntity(props.match.params.id));
  }, []);

  const aidasUserAidasObjectMappingEntity = useAppSelector(state => state.aidasUserAidasObjectMapping.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="aidasUserAidasObjectMappingDetailsHeading">AidasUserAidasObjectMapping</h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">ID</span>
          </dt>
          <dd>{aidasUserAidasObjectMappingEntity.id}</dd>
          <dt>
            <span id="dateAssigned">Date Assigned</span>
          </dt>
          <dd>
            {aidasUserAidasObjectMappingEntity.dateAssigned ? (
              <TextFormat value={aidasUserAidasObjectMappingEntity.dateAssigned} type="date" format={APP_DATE_FORMAT} />
            ) : null}
          </dd>
          <dt>
            <span id="status">Status</span>
          </dt>
          <dd>{aidasUserAidasObjectMappingEntity.status ? 'true' : 'false'}</dd>
          <dt>Aidas User</dt>
          <dd>{aidasUserAidasObjectMappingEntity.aidasUser ? aidasUserAidasObjectMappingEntity.aidasUser.firstName : ''}</dd>
          <dt>Aidas Object</dt>
          <dd>{aidasUserAidasObjectMappingEntity.aidasObject ? aidasUserAidasObjectMappingEntity.aidasObject.name : ''}</dd>
        </dl>
        <Button tag={Link} to="/aidas-user-aidas-object-mapping" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" /> <span className="d-none d-md-inline">Back</span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/aidas-user-aidas-object-mapping/${aidasUserAidasObjectMappingEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" /> <span className="d-none d-md-inline">Edit</span>
        </Button>
      </Col>
    </Row>
  );
};

export default AidasUserAidasObjectMappingDetail;
